module.exports = __webpack_public_path__ + "img/vertical_3_2_9006.4f24a71c.png";